export default "__VITE_ASSET__C$hp8FXy__"